import { useEffect, useState } from "react"
import ToggleButton from "../Shared/ToggleButton"
import AccountDropdown from "../Shared/AccountDropdown"
import useOpportunityReportType from "../Shared/useOpportunityReportType"
import ProbabilityDropdown from "../Shared/ProbabilityDropdown"
import { Checkbox } from "@prosolve/common-components-ui"
import OptionalFormFieldWrapper from "../Shared/OptionalFormFieldWrapper"

export default ({
  filter: defaultFilter,
  opportunities: defaultOpportunities,
  onFilteredOpportunitiesChange
}) => {
  const [filter, setFilter] = useState(defaultFilter || {})
  const [opportunities, setOpportunities] = useState(defaultOpportunities || [])
  const [isRemainingToShip, setIsRemainingToShip] = useState(defaultFilter?.isRemainingToShip)

  const { reportTypes, filterOpportunitiesByReportType } = useOpportunityReportType()

  const { accountId, reportType } = filter

  const onAccountChange = (val) => {
    const filterClone = {
      ...filter,
      accountId: val
    }
    setFilter(filterClone)
  }

  const onReportTypeChange = (val) => {
    const filterClone = {
      ...filter,
      reportType: (filter.reportType === val ? undefined: val)
    }
    setFilter(filterClone)
  }

  const onProbabilityChange = (val) => {
    const filterClone = {
      ...filter,
      probability: val
    }
    setFilter(filterClone)
  }

  const onRemainingToShipChange = (e) => {
    const val = e.target.checked
    console.log('onRemainingToShipChange', e, val, e.target.checked)
    const filterClone = {
      ...filter,
      isRemainingToShip: val
    }
    setFilter(filterClone)
    setIsRemainingToShip(val)
  }

  const updateFilteredOpportunities = () => {
    const filteredOpportunities = filterOpportunitiesByReportType(opportunities, reportType).filter(o => {
      if (accountId && o.AccountId !== accountId) return false
      return true
    }).slice(0, 50)
    //console.log('updateFilteredOpportunities', 'filter', filter, 'filteredOpportunities', filteredOpportunities)
    onFilteredOpportunitiesChange(filteredOpportunities, filter)
  }

  useEffect(() => {
    setOpportunities(defaultOpportunities)
  }, [defaultOpportunities])

  useEffect(() => {
    updateFilteredOpportunities()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [opportunities, filter])

  return (
    <>
      <div style={{ display: 'flex', gap: '15px', paddingBottom: '20px' }}>
        <AccountDropdown onChange={onAccountChange} />
        <ProbabilityDropdown probability={filter.probability} onChange={onProbabilityChange} />
        <OptionalFormFieldWrapper isEnabled={true} label='Remaining to Ship'>
          <Checkbox 
            key="isRemainingToShip"
            value={isRemainingToShip}
            onChange={onRemainingToShipChange}
          />
        </OptionalFormFieldWrapper>
      </div>

      <div style={{ paddingBottom: '20px' }}>
        {reportTypes.map(r => (
          <ToggleButton key={r.id} on={(r.id === reportType).toString()} onClick={() => { onReportTypeChange(r.id) }}>{r.buttonTitle}</ToggleButton>
        ))}
      </div>
    </>
  )
}